/* eslint-disable component-structure/enforce-component-structure -- Error boundaries must be class components and cannot follow Container/View pattern */
/**
 * AIPlayerSummaryErrorBoundary component entry point
 *
 * Exports the Error Boundary component. Note: Error Boundaries must be
 * class components and cannot follow the Container/View pattern.
 */
export { default } from "./AIPlayerSummaryErrorBoundary";
/* eslint-enable component-structure/enforce-component-structure -- Re-enable rule after error boundary exception */
